import { render, staticRenderFns } from "./SessionHistory.vue?vue&type=template&id=4c18d561&"
import script from "./SessionHistory.vue?vue&type=script&lang=js&"
export * from "./SessionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports